import { useEffect } from "react";

export default function useSyncfusionSourceCodeToggle(editorId = "") {
  useEffect(() => {
    const selector = editorId
      ? `#${editorId} .e-rte-container`
      : ".e-richtexteditor .e-rte-container";
    const rteContainer = document.querySelector(selector);
    if (!rteContainer) return;

    const updateDisplay = () => {
      const rteContent = rteContainer.querySelector(".e-rte-content");
      const sourceContent = rteContainer.querySelector(".e-source-content");

      if (!sourceContent) return;
      if (rteContainer.classList.contains("e-source-code-enabled")) {
        sourceContent.style.display = "";
        rteContent.style.display = "none";
      } else {
        sourceContent.style.display = "none";
        rteContent.style.display = "";
      }
    };

    const observer = new MutationObserver(updateDisplay);
    observer.observe(rteContainer, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["class"],
    });

    updateDisplay();

    return () => observer.disconnect();
  }, [editorId]);
}
